import {
  TabView as BaseTabView,
  TabDefinition,
} from '@features/campaigns/components/TabView';
import { SalesMetrics } from './sales/SalesMetrics';
import { ContributionMetrics } from './sales/ContributionMetrics';
import { RslReport } from '../../api/schema';
import { Box, Typography } from '@mui/material';
import { Highlights } from '../Highlights';
import { AdSpendCard } from './sales/AdSpendCard';
import { Campaign } from '@features/campaigns/subdomains/visitation/api';
import { Summary as VisitSummary } from './visit/Summary';

type SummaryTabsProps = {
  allReports: RslReport[];
  report: RslReport;
  campaign: Pick<
    Campaign,
    'id' | 'name' | 'startDate' | 'endDate' | 'salesRequested'
  >;
};

export const SummaryTabs = ({
  allReports,
  report,
  campaign,
}: SummaryTabsProps) => {
  const tabs: TabDefinition[] = [
    {
      label: 'Sales',
      component: (
        <>
          <Typography variant="h6" sx={{ mb: '1rem' }}>
            Sales Summary
          </Typography>

          <AdSpendCard
            campaign={campaign}
            reportDate={report.reportDate}
            incrementalSales={report.projectedIncrementalSales}
            totalSales={report.totalProjectedSales}
          />

          <Box sx={{ mt: '1rem' }}>
            <BaseTabView
              tabs={[
                {
                  label: 'Sales Metrics',
                  component: (
                    <SalesMetrics
                      reports={allReports}
                      selectedReport={report}
                      highlightsComponent={
                        <Highlights
                          report={report}
                          campaignName={campaign.name}
                        />
                      }
                    />
                  ),
                  path: 'sales-metrics',
                },
                {
                  label: 'Contribution Metrics',
                  component: (
                    <ContributionMetrics
                      reports={allReports}
                      selectedReport={report}
                      highlightsComponent={
                        <Highlights
                          report={report}
                          campaignName={campaign.name}
                        />
                      }
                    />
                  ),
                  path: 'contribution-metrics',
                },
              ]}
              backgroundColor="white"
              borderBottom={false}
            />
          </Box>
        </>
      ),
      path: 'sales',
    },
    {
      label: 'Visit',
      component: (
        <VisitSummary
          report={report}
          reports={allReports}
          campaign={campaign}
        />
      ),
      path: 'visit',
    },
  ];

  return <BaseTabView tabs={tabs} backgroundColor="white" />;
};
